import React, { useContext, useEffect } from 'react'
import QuizSectionTemplate from '../QuizSectionTemplate'
import Explaination from '../Explaination'
import { Flex, LoadingOverlay, Select } from '@mantine/core'
import CustomTextInput from '@components/inputs/quiz/CustomTextInput'
import QuizParameterTemplate from '../QuizParameterTemplate'
import { useParams } from 'react-router-dom'
import { QuizContext } from '@context/QuizContext'
import RoundButton from '@components/button/RoundButton'
import Quiz from '@api/Quiz'
import TwoButtonInput from '@components/form/quiz/TwoButtonInput'

const QuizSectionOne = () => {
    const params = useParams()
    const { form1, nextStep, currentStep, setQuiz, quiz_id } =
        useContext(QuizContext)

    if (quiz_id) form1!.values.quiz_id = quiz_id

    const { isLoading, onSubmit } = Quiz.useCreateQuiz({
        form: form1,
        aftersuccess: (res) => {
            setQuiz!(res)
            nextStep!()
        },
    })

    useEffect(() => {
        form1?.setFieldValue(
            'person_type',
            params.person_type === 'employee' ? 1 : 2
        )
        // eslint-disable-next-line
    }, [params])

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value.replace(/[^0-9]/g, '')
        form1?.setFieldValue('person_id', newValue)
    }

    if (currentStep !== 1) {
        return <></>
    }

    const dropdownDataQ1 = [
        {
            label: 'เกษียณอายุอย่างมั่นคง',
            value: 'เกษียณอายุอย่างมั่นคง',
        },
        {
            label: 'เกษียณอายุเร็ว',
            value: 'เกษียณอายุเร็ว',
        },
        {
            label: 'อิสระภาพทางการเงิน',
            value: 'อิสระภาพทางการเงิน',
        },
        {
            label: 'สร้างสมดุลสำหรับชีวิต',
            value: 'สร้างสมดุลสำหรับชีวิต',
        },
        {
            label: 'ท่องเที่ยวพักผ่อนตามใจต้องการ',
            value: 'ท่องเที่ยวพักผ่อนตามใจต้องการ',
        },
        {
            label: 'เดินทางท่องเที่ยวรอบโลก',
            value: 'เดินทางท่องเที่ยวรอบโลก',
        },
        {
            label: 'ออมเงินเพื่อการศึกษา',
            value: 'ออมเงินเพื่อการศึกษา',
        },
        {
            label: 'ซื้อรถในฝันที่ต้องการ',
            value: 'ซื้อรถในฝันที่ต้องการ',
        },
        { label: 'ซื้อบ้านในฝัน', value: 'ซื้อบ้านในฝัน' },
        {
            label: 'แต่งงานสร้างครอบครัว',
            value: 'แต่งงานสร้างครอบครัว',
        },
        {
            label: 'เตรียมความพร้อมสำหรับการมีบุตร',
            value: 'เตรียมความพร้อมสำหรับการมีบุตร',
        },
        {
            label: 'ชำระหนี้ให้หมด',
            value: 'ชำระหนี้ให้หมด',
        },
        {
            label: 'บรรลุเป้าหมายใหญ่ ๆ ในชีวิต',
            value: 'บรรลุเป้าหมายใหญ่ ๆ ในชีวิต',
        },
        {
            label: 'พัฒนาตนเองอย่างต่อเนื่อง',
            value: 'พัฒนาตนเองอย่างต่อเนื่อง',
        },
        {
            label: 'ดูแลสุขภาพในอนาคต',
            value: 'ดูแลสุขภาพในอนาคต',
        },
        {
            label: 'สร้างเงินสำรองฉุกเฉิน',
            value: 'สร้างเงินสำรองฉุกเฉิน',
        },
        { label: 'วางแผนมรดก', value: 'วางแผนมรดก' },
        { label: 'อื่น ๆ', value: 'อื่น ๆ' },
    ]

    return (
        <form onSubmit={onSubmit}>
            <LoadingOverlay visible={isLoading} />
            <Explaination />
            <QuizSectionTemplate section={1} title='ข้อมูลส่วนตัว'>
                <QuizParameterTemplate
                    label={
                        params.person_type === 'employee'
                            ? 'รหัสพนักงาน'
                            : 'เลขประจำตัวประชาชน 5 ตัวท้าย'
                    }
                    required
                >
                    <CustomTextInput
                        maxLength={params.person_type === 'employee' ? 6 : 5}
                        {...form1!.getInputProps('person_id')}
                        onChange={handleInputChange}
                    />
                </QuizParameterTemplate>
            </QuizSectionTemplate>
            <QuizSectionTemplate
                section={''}
                title='แบบสำรวจการวางแผนทางการเงินเพื่อการเกษียณ'
            >
                <QuizParameterTemplate
                    label='เป้าหมายชีวิตและเป้าหมายทางการเงินของคุณวันนี้คือ ?'
                    required
                >
                    <Select
                        w={200}
                        styles={{
                            input: {
                                borderColor: 'var(--mantine-color-gray-2)',
                                textAlign: 'end',
                            },
                        }}
                        data={dropdownDataQ1}
                        min={50}
                        max={65}
                        {...form1!.getInputProps('question_1')}
                    />
                </QuizParameterTemplate>
                {form1?.values.question_1 === 'อื่น ๆ' && (
                    <QuizParameterTemplate label=''>
                        <CustomTextInput
                            {...form1!.getInputProps('question_1_other')}
                            placeholder='โปรดระบุ'
                            onChange={(e) => {
                                form1?.setFieldValue(
                                    'question_1_other',
                                    e.target.value
                                )
                            }}
                        />
                    </QuizParameterTemplate>
                )}
                <QuizParameterTemplate
                    label='คุณคิดว่าเงินออมต่อเดือน ควรเป็นกี่เปอร์เซ็นของรายได้'
                    required
                >
                    <Select
                        w={200}
                        styles={{
                            input: {
                                borderColor: 'var(--mantine-color-gray-2)',
                                textAlign: 'end',
                            },
                        }}
                        data={[
                            {
                                label: 'น้อยกว่า 10%',
                                value: 'น้อยกว่า 10%',
                            },
                            {
                                label: '10-20%',
                                value: '10-20%',
                            },
                            {
                                label: 'มากกว่า 20%',
                                value: 'มากกว่า 20%',
                            },
                        ]}
                        {...form1!.getInputProps('question_2')}
                    />
                </QuizParameterTemplate>
                <QuizParameterTemplate
                    label='คุณมีแนวความคิดอย่างไรในเรื่องของการวางแผนเกษียณ'
                    required
                >
                    <Select
                        w={200}
                        styles={{
                            input: {
                                borderColor: 'var(--mantine-color-gray-2)',
                                textAlign: 'end',
                            },
                        }}
                        data={[
                            {
                                label: 'ไม่มีความจำเป็นต้องวางแผนเกษียณ',
                                value: 'ไม่มีความจำเป็นต้องวางแผนเกษียณ',
                            },
                            {
                                label: 'ทำก็ได้ ไม่ทำก็ไม่เป็นไร',
                                value: 'ทำก็ได้ ไม่ทำก็ไม่เป็นไร',
                            },
                            {
                                label: 'จำเป็นต้องทำเพื่อความมั่นคงของชีวิต',
                                value: 'จำเป็นต้องทำเพื่อความมั่นคงของชีวิต',
                            },
                        ]}
                        {...form1!.getInputProps('question_3')}
                    />
                </QuizParameterTemplate>
                <QuizParameterTemplate
                    label='คุณเคยคำนวณเงินเพื่อการเกษียณแล้วหรือยัง'
                    required
                >
                    <TwoButtonInput
                        label1='เคย'
                        label2='ไม่เคย'
                        {...form1!.getInputProps('question_4')}
                    />
                </QuizParameterTemplate>
            </QuizSectionTemplate>
            <Flex mb='xl'>
                <RoundButton
                    type='submit'
                    miw={{ xs: '100%', md: '160px' }}
                    label='เริ่มคํานวณ'
                    ml='auto'
                />
            </Flex>
        </form>
    )
}

export default QuizSectionOne
